import { createContext } from 'react';

import { DEFAULT_TRANSLATIONS } from '../constants';
import type { AppContextValue } from '../types';

export const appContext = createContext<AppContextValue>({
  translations: DEFAULT_TRANSLATIONS,
  // This will be replaced when rendering, because we wont render the app without data
  data: {
    catalogueItemId: '0',
    choiceId: 0,
    consultantPrice: 0,
    itemCode: '0',
    loyaltyPoints: 0,
    loyaltyPrice: 0,
    productName: 'none',
    quantity: 0,
  },
});
